import { z } from 'zod';

const sharedSurveySchema = z.object({
  surveyGroupId: z.string().min(1),
  slug: z.string().min(1).nullable().catch(null),
  name: z.string().min(1),
  type: z.string().optional().catch(undefined),
});

export type SharedSurvey = z.infer<typeof sharedSurveySchema>;

/**
 * A survey a support message hands the member, as its card shows it: the
 * snapshot the API stores on the message when staff share one, or what the
 * picker showed for a message still sending.
 *
 * Null when the group id or name is missing, which decides whether there is a
 * card at all. Attributes are free-form, so a malformed one costs the card and
 * never the thread.
 *
 * Kept apart from the thread service, which pulls in the API client, so the
 * pure thread-item builder can use it without loading auth.
 */
export function toSharedSurvey(value: unknown): SharedSurvey | null {
  const result = sharedSurveySchema.safeParse(value);

  return result.success ? result.data : null;
}

/**
 * Where a shared survey opens. The slug reads better in a link when the survey
 * has one; either resolves to whichever version is published when it is opened.
 */
export function sharedSurveyRouteId(survey: Pick<SharedSurvey, 'surveyGroupId' | 'slug'>): string {
  return survey.slug ?? survey.surveyGroupId;
}
